import { CustomLineItem, LineItem } from "@commercetools/platform-sdk";

export function getCartItemName({ name }: LineItem | CustomLineItem) {
  // todo: add logic to handle different locales
  return name["en-GB"] || name["en-US"] || name["en"];
}
